import get from 'lodash/get';
import filter from 'lodash/filter';
import forEach from 'lodash/forEach';
import each from 'lodash/each';
import last from 'lodash/last';
import map from 'lodash/map';
import compact from 'lodash/compact';
import clone from 'lodash/clone';
import { getBasicById } from '../lib/api';
import { getObjectBylang } from '../utils';
import PatentUtils from '../utils/patent_utils';
import legalMap from '../config/legal-mapping';
import calculatePatentValueLevel from '../utils/calculatePatentValueLevel';
import formatNumber from '../lib/familytree/utils/formatNumber';
import Service from './Service';
import { RequestChannel } from '@patsnap/common-ps-http';
import { getCurrentLanguage } from 'library-@/utils/getCurrentLanguage';
import { getValuationApi } from 'library-@/apis/core_basic_api/patent';
import { injectService } from '@patsnap/tahiti-core/ioc/inject';
import { FreeViewLimitService } from '@/components/no-permission/service/free-view-limit.service';

function initOriginTranslate(data, field) {
    const { LANG_DEFAULT } = data;

    let lang = LANG_DEFAULT;
    window.CURRENT_LANG_DEFAULT = LANG_DEFAULT;
    let value = get(data, `${field}.${lang}`);

    if (!value) {
        const fieldValue = get(data, field);
        [lang] = Object.keys(fieldValue || {});
        value = get(fieldValue, lang);
    }

    data[`Origin_${field}`] = value;
    data[`Origin_${field}_Lang`] = lang;

    return value;
}

function isDisplayPatent(types) {
    for (var i = 0; i < types.length; i++) {
        if (/^[a-zA-Z]{2}D$/.test(types[i])) {
            return true;
        }
    }
    return false;
}

export function before(_data) {
    if (!_data) {
        return {};
    }
    let data = { ..._data };

    forEach(data, function(v, k) {
        if ($.isArray(v) && v.length === 0) {
            data[k] = false;
        }
    });

    try {
        if (data.LEGAL_STATUS && data.LEGAL_STATUS.length) {
            var legalHandled = map(data.LEGAL_STATUS, function(v) {
                var obj = {};
                obj.value = v;
                obj.label = legalMap[v];

                return obj;
            });

            data.legalHandled = legalHandled;
        }

        data.ORIGINAL_PN = data.ORIGINAL_PN || {};
        var espacenet = PatentUtils.getEspacenetLink(get(data, 'ORIGINAL_PN.docdb'), get(data, 'FAMILY_ID'));
        var inpadocLink = PatentUtils.getInpadocLink(get(data, 'ORIGINAL_PN.docdb'));
        var official = PatentUtils.getOfficialLink(data.PN, data.APN, data.PBD, data.TYPE);
        data.EXTERNAL_LINKS = compact([espacenet, official]);
        data.INPADOC_LINK = inpadocLink;

        // 翻译字段适配
        each(['ABST', 'TITLE', 'AN', 'ANC', 'IN', 'ATC', 'AT_C', 'AT', 'PE', 'AE', 'GOV', 'AP_F', 'INC', 'ATC_C'], function(field) {
            initOriginTranslate(data, field);
        });
        // ------------ 外观专利不展示专利价值 $$$$$
        data.isNoValuation = isDisplayPatent(data.TYPE);
        if (!data.isNoValuation) {
            var level = calculatePatentValueLevel(data.valuation);
            if (level > 0) {
                data.valuation = `$ ${formatNumber(data.valuation)}`;
                data.patent_value_levels = level;
            } else {
                data.valuation = '';
            }
        }
    } catch (error) {
        console.error(error);
    }
    return data;
}

export function abstHandler(_data) {
    const data = { ..._data };
    var transferHistory = get(data, 'TRANSFER');
    var currentLang = getCurrentLanguage();

    var type = get(data, 'TYPE');
    var linksFiltered;
    var hasDesignPatent;
    if (type) {
        hasDesignPatent = type.some(function(item) {
            return item.charAt(item.length - 1) === 'D';
        });
    }
    if (hasDesignPatent) {
        linksFiltered = filter(data.EXTERNAL_LINKS, function(item) {
            return item.name !== 'Espacenet';
        });
    } else {
        linksFiltered = data.EXTERNAL_LINKS;
    }

    data.linksFiltered = map(linksFiltered, filter => {
        filter.className = filter.name;

        if (filter.name !== 'Inpadoc') {
            filter.name = '';
        }

        return filter;
    });

    if (data.STANDARD && data.STANDARD.length) {
        data.STANDARD = map(data.STANDARD, standard => {
            return Object.assign({}, standard, {
                showTable: false,
                showAll: false,
            });
        });
    }

    if (transferHistory && transferHistory.length) {
        try {
            var hList = [];

            transferHistory = clone(transferHistory).reverse();

            each(transferHistory, function(o, idx) {
                if (idx === 0 && o.transfer_before) {
                    last(o.transfer_before).isLast = true;

                    hList.push({
                        person: o.transfer_before
                    });
                }

                last(o.transfer_after).isLast = true;

                hList.push({
                    person: o.transfer_after,
                    date: o.prsd
                });
            });
            data.transferHistory = hList;
        } catch (error) {
            console.error(error);
        }
    }

    // 处理接续案数据
    // 上面的before方法中会把空数组改成false
    const continuationFrom = get(data, 'CONTINUATION_FROM_APN') || [];
    data.CONTINUATION_FROM = continuationFrom.map((item, index) => ({
        name: item,
        type: get(data, `CONTINUATION_TYPE[${index}]`)
    }));

    data.currentLang = currentLang;

    // format jpdc数据
    if (data.JPDC_DTERM) {
        const _JPDC_DTERM = get(data, 'JPDC_DTERM', {});
        data.JPDC_DTERM = {};
        /* 分为三种情况
        *  包含dterm的jpdc，在jpdc_dterm字段中取值
        *  不包含dterm的jpdc，在jpdc字段中取值
        *  只有dterm，在dterm字段中取值
        *  */
        const JPDC_DTERM = get(_JPDC_DTERM, 'jpdc_dterm', []);
        const JPDC = get(_JPDC_DTERM, 'jpdc', []);
        const DTERM = get(_JPDC_DTERM, 'dterm', []);
        // 合并JPDC和Dterm数据
        each(JPDC, item => {
            JPDC_DTERM.push({
                jpdc: item
            });
        });
        const JPDCDtermList = map(JPDC_DTERM, item => {
            return {
                name: item.jpdc,
                dterm: item.dterm || []
            };
        });
        if (JPDCDtermList.length) {
            data.JPDC_DTERM.JPDCDtermList = JPDCDtermList;
        }
        if (DTERM.length) {
            data.JPDC_DTERM.dtermList = DTERM;
        }
    }

    return data;
}
export default class BasicService extends Service {
    constructor(patentId) {
        super();
        this.patentId = patentId;
        this.pn = undefined;
    }

    get patent() {
        return undefined;
    }

    static getObjectBylang = getObjectBylang

    // static createBasicService(patentId) {
    //     return cache || new BasicService(patentId);
    // }

    static getPatentDefaultOfAbst(baseResp) {
        const { ABST = {}, ABST_LANG, LANG_DEFAULT } = baseResp || {};
        const lang = ABST_LANG || LANG_DEFAULT;
        const text = getObjectBylang(ABST, lang) || '';
        return { lang, text };
    }

    static getPatentDefaultOfTitle(baseResp) {
        const { TITLE = {}, TITLE_LANG, LANG_DEFAULT } = baseResp || {};
        const lang = TITLE_LANG || LANG_DEFAULT;
        const text = getObjectBylang(TITLE, lang) || '';
        return { lang, text };
    }

    getPatentBase() {
        if (this.patent) {
            return Promise.resolve(this.patent);
        }
        return RequestChannel.toPromise(getBasicById(this.patentId), sub => this.subscriptions.add(sub))
            .then(async ([basicInfo = {}, tabInfo = {}]) => {
                const res = {
                    ...basicInfo,
                    data: {
                        ...(basicInfo.data || {}),
                        ...(tabInfo.data || {})
                    }
                };
                const { getI18nInstance } = await import('../locales/i18nInstance');
                const _i18n = getI18nInstance();
                try {
                    if (get(res, 'error_code') === 11160405) {
                        const freeViewLimitService = injectService(FreeViewLimitService);
                        freeViewLimitService.updateState(true, _i18n.t('commonStatusCode.11160405'));
                    }
                    return before(res.data);
                } catch (error) {
                    console.error(error);
                    return res.data;
                }
            })
            .then(res => abstHandler(res))
            .then(res => {
                this.pn = res.PN;
                Object.defineProperty(this, 'patent', {
                    configurable: true,
                    get() {
                        return res;
                    }
                });
                // 不可以return res
                return this.patent;
            });
    }

    async getValuation () {
        const resp = await getValuationApi(this.patentId);
        const {
            // 独立权利要求
            indep_claim_count = 0,
            //是否被提过无效或异议
            invalid_opposition = false,
            // 简单同族数量
            simple_family_count = 0,
            // 简单同族布局国家和地区数量
            simple_family_country = 0,
            // 被引用专利数量
            cited_count = 0,
            // 发明人数量
            inventor_count = 0,
            // 同类技术近3年专利增长率  后面需要跟上%
            growth_rate = 0,
            // 是否有许可或转移
            license_or_transfer = false,
            // 简单同族中有效专利分布国家/地区
            family_active_area = [],
            //维持年限
            maintenance_period = 0
        } = resp;
        return {
            indepClaimCount: indep_claim_count,
            invalidOpposition: invalid_opposition,
            simpleFamilyCount: simple_family_count,
            simpleFamilyCountry: simple_family_country,
            citedCount: cited_count,
            inventorCount: inventor_count,
            growthRate: growth_rate,
            licenseOrTransfer: license_or_transfer,
            familyActiveArea: family_active_area,
            maintenancePeriod: maintenance_period
        };
    }
}
